import React, { useCallback } from 'react';
import { ReactSVG } from 'react-svg';
import './Visage2Icon.scss';

interface IProps {
    icon: string;
    type?: "bold" | "outline" | "custom" | undefined;
    size?: "extra-small" | "small" | "medium" | "big" | "extra-big" | undefined;
    color?: spintrColors;
    hexColor?: string;
    className?: string;
    title?: string;
    style?: any;
    useStrokeForColor?: boolean;
    rotation?: number;
}

const Visage2Icon = (props: IProps) => {
    const beforeInjection = useCallback((svg: SVGSVGElement) => {
        if (!props.hexColor) return;

        Array.from(svg.children).forEach((child) => {
            if (child instanceof SVGElement) {
                if (props.useStrokeForColor) {
                    child.style.stroke = props.hexColor;
                } else {
                    child.style.fill = props.hexColor;
                }
            }
        });
    }, [props.hexColor, props.useStrokeForColor]);

    if (!props.icon) {
        return null;
    }

    const src = "/visage2icons/" + (props.type || "outline") + "/" + props.icon + ".svg";

    const classes = ["Visage2Icon",
        ("Visage2Icon-" + props.icon.toLowerCase()),
        (props.className || ""),
        ("icon-size-" + (props.size || "medium"))];

    if (props.color || !props.hexColor) {
        classes.push("icon-color-" + (props.color || "dark-grey"));
    }

    const className = classes.filter(x => !!x).join(" ");

    if (!props.icon) {
        return null;
    }

    return (
        <ReactSVG
            src={src}
            title={props.title}
            className={className}
            style={{
                ...props.style,
                ...(props.rotation
                    ? {
                          rotate: `${props.rotation}deg`,
                      }
                    : {}),
            }}
            beforeInjection={beforeInjection}
            fallback={() => {
                console.log("ICON ERROR: '" + src + "' NOT FOUND.")
                return null;
            }} />
    )
}

export default Visage2Icon;